import { Component, Input } from "@angular/core";

@Component({
    selector: "app-additional-values",
    templateUrl: "./additional-values.component.html",
    styleUrls: ["./additional-values.component.scss"],
})
export class AdditionalValuesComponent {
    @Input() public additionalValues: string[] = [];
    @Input() public includePaddingInMinWidth = false; // We need this to ensure that the badge is circular, we had issues with this in the prime table and outside it

    public getAdditionalValuesTooltip(): string {
        return this.additionalValues.join(", ");
    }
}
